/**
 * Animation de cœur qui s'envole quand on le perd
 */
import React, { useEffect, useState } from 'react';
import { Heart } from 'lucide-react';

const HeartLostAnimation = ({ show }) => {
  const [visible, setVisible] = useState(false);
  const [position, setPosition] = useState({ y: 0, opacity: 1, scale: 1 });
  
  useEffect(() => {
    if (!show) return;
    
    setVisible(true);
    setPosition({ y: 0, opacity: 1, scale: 1 });
    
    // Animation
    let frame = 0;
    const animate = () => {
      frame++;
      const y = frame * 3;
      const opacity = Math.max(0, 1 - frame / 25);
      const scale = 1 + frame * 0.02;
      
      setPosition({ y, opacity, scale });
      
      if (frame < 25) {
        requestAnimationFrame(animate);
      } else {
        setVisible(false);
      }
    };
    
    requestAnimationFrame(animate);
  }, [show]);
  
  if (!visible) return null;
  
  return (
    <div 
      className="fixed top-20 right-20 z-50 pointer-events-none"
      style={{
        transform: `translateY(-${position.y}px) scale(${position.scale})`,
        opacity: position.opacity
      }}
    >
      <div className="relative">
        <Heart className="w-12 h-12 text-red-500 fill-red-500" />
        <div className="absolute inset-0 flex items-center justify-center">
          <span className="text-white font-bold text-lg">-1</span>
        </div>
      </div>
    </div>
  );
};

export default HeartLostAnimation;
